"use client"

import { Button } from "@/components/ui/button"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { User, Bot } from "lucide-react"
import { useAigency } from "@/components/aigency-modal/AigencyContext"

// Hardcoded intern data (same as in intern-member.tsx)
const INTERN_CANDIDATES = [
  {
    _id: "k578w6eb8xawpsmjbfbfvmm8497p650g",
    vapiId: "21cced8b-3e1e-454a-b0e6-826bcfc6203a",
    name: "Intern Candidate #1",
    role: "AI Intern",
    firstMessage: "Hello! I'm excited to discuss how I can contribute to TRPC.",
    instructions: "You open your eyes and are in the middle of dimly lit room..."
  },
  {
    _id: "k578tsanqf0d7k6dpvza5qerc57p6cth",
    vapiId: "153c3dac-d80b-4cc7-8d0f-39ba7e7051c7",
    name: "Hannah",
    role: "Customer Engagement Intern",
    firstMessage: "Hi, thanks for calling TRPC. This is Hannah. Happy to walk through your idea or if you have any question about TRPC.",
    instructions: "You are Hannah, the Inbound Customer Engagement Representative..."
  },
  {
    _id: "intern_candidate_3",
    vapiId: "886caf53-7df2-4eb8-8899-1ac36eab0313",
    name: "Intern Candidate #3",
    role: "AI Intern",
    firstMessage: "Greetings! I'm ready to showcase my skills and learn from the TRPC team.",
    instructions: "An eager AI intern ready to prove their worth..."
  }
]

interface DualCTAProps {
  showIcons?: boolean
  size?: "default" | "sm" | "lg"
  className?: string
}

export function DualCTA({ 
  showIcons = true, 
  size = "lg",
  className = ""
}: DualCTAProps) {
  const { openConversation } = useAigency()

  const handleBookCall = () => {
    openConversation({
      _id: `team-Khurram Ahmad`,
      name: "Khurram Ahmad",
      displayName: "Khurram",
      role: "Co-Founder",
      calendlyUrl: "trpc-book/30min",
      linkedinUrl: "https://www.linkedin.com/in/khurramahmad",
      twitterUrl: "https://x.com/koojam",
      imageSrc: "/images/khurram.png"
    }, 'human')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChatWithIntern = () => {
    // Select a random intern
    const randomIntern = INTERN_CANDIDATES[Math.floor(Math.random() * INTERN_CANDIDATES.length)]
    
    // Open the conversation modal with the random intern
    openConversation({
      _id: randomIntern._id,
      vapiId: randomIntern.vapiId,
      name: randomIntern.name,
      role: randomIntern.role,
      firstMessage: randomIntern.firstMessage,
      instructions: randomIntern.instructions
    }, 'assistant')
  }

  return (
    <div className={`flex flex-col sm:flex-row gap-4 justify-center ${className}`}>
      <Button 
        size={size}
        onClick={handleBookCall}
        className={size === "lg" ? "px-8 py-6 text-lg w-full sm:w-auto" : "w-full sm:w-auto"}
      >
        {showIcons && <User className="h-5 w-5 mr-2" />}
        Book a Discovery Call
      </Button>

      {/* HIDDEN — intern AI CTA. Restore when re-enabling the AI intern flow.
      <Button
        size={size}
        variant="outline"
        onClick={handleChatWithIntern}
        className={size === "lg" ? "px-8 py-6 text-lg relative w-full sm:w-auto" : "relative w-full sm:w-auto"}
        style={{
          boxShadow: '0 0 20px rgba(124, 58, 237, 0.5), 0 0 40px rgba(59, 130, 246, 0.3)',
          border: '1px solid rgba(124, 58, 237, 0.6)'
        }}
      >
        {showIcons && <Bot className="h-5 w-5 mr-2" />}
        Chat with Our Intern
      </Button>
      */}
    </div>
  )
}